module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }]
  }, [_c('div', {
    staticClass: "page-header"
  }, [(_vm.$route.params.area == 'invitation') ? _c('el-dropdown', {
    staticClass: "page-menu",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.invitationMenu
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("more_vert")])]), _vm._v(" "), _c('el-dropdown-menu', {
    staticStyle: {
      "min-width": "50px",
      "color": "#666666"
    },
    slot: "dropdown"
  }, [(_vm.$route.params.page != 'president-invitation') ? _c('el-dropdown-item', {
    attrs: {
      "command": "president-invitation"
    }
  }, [_vm._v("President's Invitation")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.page != 'society-invitation') ? _c('el-dropdown-item', {
    attrs: {
      "command": "society-invitation"
    }
  }, [_vm._v("IFCC President invitation")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.page != 'auspices') ? _c('el-dropdown-item', {
    attrs: {
      "command": "auspices"
    }
  }, [_vm._v("Auspices")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.page != 'mayor-of-athens') ? _c('el-dropdown-item', {
    attrs: {
      "command": "mayor-of-athens"
    }
  }, [_vm._v("Mayor of Athens")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.area == 'info') ? _c('el-dropdown', {
    staticClass: "page-menu",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.infoMenu
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("more_vert")])]), _vm._v(" "), _c('el-dropdown-menu', {
    staticStyle: {
      "min-width": "50px",
      "color": "#666666"
    },
    slot: "dropdown"
  }, [(_vm.$route.params.page != 'congress-venue') ? _c('el-dropdown-item', {
    attrs: {
      "command": "congress-venue"
    }
  }, [_vm._v("Congress venue")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.page != 'reach-maicc') ? _c('el-dropdown-item', {
    attrs: {
      "command": "reach-maicc"
    }
  }, [_vm._v("How to reach MAICC")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.page != 'get-athens') ? _c('el-dropdown-item', {
    attrs: {
      "command": "get-athens"
    }
  }, [_vm._v("How to get Athens")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "metromap"
    }
  }, [_vm._v("Metro MAP")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-in"
  }, [_c('div', {
    staticClass: "page-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.page)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-742a9aff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = 362
// module chunks = 0